<template>
  <div class="response">
    <div style="width: 55%; margin: 0px 3%; text-align: left">
      <responseRight></responseRight>
      <codeRight
        :str="str"
        :pythonStr="pythonStr"
        :jsStr="jsStr"
        :goStr="goStr"
        :javaStr="javaStr"
        :ellStr="ellStr"
        :sllStr="sllStr"
        :slyStr="slyStr"
        :slsStr="slsStr"
        :srjStr="srjStr"
        :wlsStr="wlsStr"
        :wlfStr="wlfStr"
        style="
          position: absolute;
          top: 24px;
          right: 20px;
          width: 450px;
          display: flex;
          flex-direction: column;
          height: calc(100vh - 231px);
        "
      ></codeRight>
    </div>
    <!-- <div style="width:450px">
     
        </div> -->
  </div>
</template>
<script>
import responseRight from "./responseRight.vue";
import codeRight from "./codeRight.vue";

export default {
  name: "Home",
  components: {
    responseRight,
    codeRight,
  },
  data() {
    return {
      str: `curl --request POST 
  --url ${this.$codeUrl}chat/completions 
  --header 'Authorization: Bearer <token>' 
  --header 'Content-Type: application/json' 
  --data '{
  "model": "Qwen/QwQ-32B",
  "messages": [
    {
      "role": "user",
      "content": "What opportunities and challenges will the Chinese large model industry face in 2025?"
    }
  ],
  "stream": false,
  "max_tokens": 512,
  "stop": null,
  "temperature": 0.7,
  "top_p": 0.7,
  "top_k": 50,
  "frequency_penalty": 0.5,
  "n": 1,
  "response_format": {
    "type": "text"
  },
  "tools": [
    {
      "type": "function",
      "function": {
        "description": "<string>",
        "name": "<string>",
        "parameters": {},
        "strict": false
      }
    }
  ]
}'`.trim(),
      jsStr: `const options = {
  method: 'POST',
  headers: {Authorization: 'Bearer <token>', 'Content-Type': 'application/json'},
  body: '{"model":"Qwen/QwQ-32B","messages":[{"role":"user","content":"What opportunities and challenges will the Chinese large model industry face in 2025?"}],"stream":false,"max_tokens":512,"stop":null,"temperature":0.7,"top_p":0.7,"top_k":50,"frequency_penalty":0.5,"n":1,"response_format":{"type":"text"},"tools":[{"type":"function","function":{"description":"<string>","name":"<string>","parameters":{},"strict":false}}]}'
};

fetch('${this.$codeUrl}chat/completions', options)
  .then(response => response.json())
  .then(response => console.log(response))
  .catch(err => console.error(err));`.trim(),
      goStr: `package main

import (
	"fmt"
	"strings"
	"net/http"
	"io/ioutil"
)

func main() {

	url := "${this.$codeUrl}chat/completions"

	payload := strings.NewReader("{\n  \"model\": \"Qwen/QwQ-32B\",\n  \"messages\": [\n    {\n      \"role\": \"user\",\n      \"content\": \"What opportunities and challenges will the Chinese large model industry face in 2025?\"\n    }\n  ],\n  \"stream\": false,\n  \"max_tokens\": 512,\n  \"stop\": null,\n  \"temperature\": 0.7,\n  \"top_p\": 0.7,\n  \"top_k\": 50,\n  \"frequency_penalty\": 0.5,\n  \"n\": 1,\n  \"response_format\": {\n    \"type\": \"text\"\n  },\n  \"tools\": [\n    {\n      \"type\": \"function\",\n      \"function\": {\n        \"description\": \"<string>\",\n        \"name\": \"<string>\",\n        \"parameters\": {},\n        \"strict\": false\n      }\n    }\n  ]\n}")

	req, _ := http.NewRequest("POST", url, payload)

	req.Header.Add("Authorization", "Bearer <token>")
	req.Header.Add("Content-Type", "application/json")

	res, _ := http.DefaultClient.Do(req)

	defer res.Body.Close()
	body, _ := ioutil.ReadAll(res.Body)

	fmt.Println(res)
	fmt.Println(string(body))

}`.trim(),
      javaStr:
        `HttpResponse<String> response = Unirest.post("${this.$codeUrl}chat/completions")
  .header("Authorization", "Bearer <token>")
  .header("Content-Type", "application/json")
  .body("{\n  \"model\": \"Qwen/QwQ-32B\",\n  \"messages\": [\n    {\n      \"role\": \"user\",\n      \"content\": \"What opportunities and challenges will the Chinese large model industry face in 2025?\"\n    }\n  ],\n  \"stream\": false,\n  \"max_tokens\": 512,\n  \"stop\": null,\n  \"temperature\": 0.7,\n  \"top_p\": 0.7,\n  \"top_k\": 50,\n  \"frequency_penalty\": 0.5,\n  \"n\": 1,\n  \"response_format\": {\n    \"type\": \"text\"\n  },\n  \"tools\": [\n    {\n      \"type\": \"function\",\n      \"function\": {\n        \"description\": \"<string>\",\n        \"name\": \"<string>\",\n        \"parameters\": {},\n        \"strict\": false\n      }\n    }\n  ]\n}")
  .asString();`.trim(),
      ellStr: `{
  "id": "<string>",
  "choices": [
    {
      "message": {
        "role": "assistant",
        "content": "<string>",
        "reasoning_content": "<string>",
        "tool_calls": [
          {
            "id": "<string>",
            "type": "function",
            "function": {
              "name": "<string>",
              "arguments": "<string>"
            }
          }
        ]
      },
      "finish_reason": "stop"
    }
  ],
  "usage": {
    "prompt_tokens": 123,
    "completion_tokens": 123,
    "total_tokens": 123
  },
  "created": 123,
  "model": "<string>",
  "object": "chat.completion"
}`.trim(),
      sllStr: `{
  "code": 20012,
  "message": "<string>",
  "data": "<string>"
}`.trim(),
      slyStr: `"Invalid token"`.trim(),
      slsStr: `"404 page not found"`.trim(),
      srjStr: `{
  "message": "Request was rejected due to rate limiting. If you want more, please contact contact@siliconflow.cn. Details:TPM limit reached.",
  "data": "<string>"
}`.trim(),
      wlsStr: `{
  "code": 50505,
  "message": "Model service overloaded. Please try again later.",
  "data": "<string>"
}`.trim(),
      wlfStr: `"<string>"`.trim(),

      pythonStr: `import requests

url = "${this.$codeUrl}chat/completions"

payload = {
    "model": "Qwen/QwQ-32B",
    "messages": [
        {
            "role": "user",
            "content": "What opportunities and challenges will the Chinese large model industry face in 2025?"
        }
    ],
    "stream": False,
    "max_tokens": 512,
    "stop": None,
    "temperature": 0.7,
    "top_p": 0.7,
    "top_k": 50,
    "frequency_penalty": 0.5,
    "n": 1,
    "response_format": {"type": "text"},
    "tools": [
        {
            "type": "function",
            "function": {
                "description": "<string>",
                "name": "<string>",
                "parameters": {},
                "strict": False
            }
        }
    ]
}
headers = {
    "Authorization": "Bearer <token>",
    "Content-Type": "application/json"
}

response = requests.request("POST", url, json=payload, headers=headers)

print(response.text)`.trim(),
    };
  },
};
</script>
<style scoped>
.response {
  width: 100%;
  height: 100%;
  display: flex;
  padding-left: 250px;
  height: calc(100vh - 189px);
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
  overflow: auto;
  /* position: relative; */
}
.response::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Opera */
}
</style>